import script from "./FormulasIngredients.vue?vue&type=script&setup=true&lang=js"
export * from "./FormulasIngredients.vue?vue&type=script&setup=true&lang=js"

import "./FormulasIngredients.vue?vue&type=style&index=0&id=62807704&lang=scss"

const __exports__ = script;

export default __exports__